import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import {Template} from 'na-lib';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  allPassDefinitionsSubject$ = new BehaviorSubject<Template[]|undefined>(undefined)
  ngUnsubscribe: Subject<void> = new Subject<void>();
  allDataUsers$:any
  loggedUser:any
  darkAsLight :Subject<boolean> = new Subject<boolean>();//=true
  darkAsLightValue :boolean=false

  constructor(
    private auth: AuthService) { }


    deactiveDarkAsLight(){
      this.darkAsLightValue = false
      this.darkAsLight.next(this.darkAsLightValue)
      // this.darkAsLight.next(!this.darkAsLightValue)
    }
    activeDarkAsLight(){
      this.darkAsLightValue = true
      this.darkAsLight.next(this.darkAsLightValue)
    }

    changeDarkAsLight(){
      this.darkAsLightValue = !this.darkAsLightValue
      this.darkAsLight.next(this.darkAsLightValue)  
    }


}



